"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.object.keys");
var _typeof2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _toConsumableArray2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _mall = require("@/api/mall");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _ImgDrag = _interopRequireDefault(require("@/components/ImgDrag"));
var _TemplateEdit = _interopRequireDefault(require("@/components/BaseTemplate/TemplateEdit"));
var _previewTemp = _interopRequireDefault(require("@/components/BaseTemplate/previewTemp"));
var _elementUi = require("element-ui");
var _auth = require("@/utils/auth");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GoodsEdit',
  components: {
    Tinymce: _Tinymce.default,
    ImageDrag: _ImgDrag.default,
    TemplateEdit: _TemplateEdit.default,
    PreviewTemp: _previewTemp.default
  },
  data: function data() {
    var _ref;
    return _ref = {
      sizeList: [],
      dialogVisible2: false,
      inventoryData: {},
      laddData: [],
      laddStatus: 1,
      fee: 0,
      sizeGuide: {
        in: [],
        cm: []
      },
      cateInfoSize: null,
      compositionList: [],
      //成分
      fileList: [],
      gifList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      // columns: [],
      // columns2: [],
      specListTab: [],
      activeSizeType: 2,
      // 尺码
      checkSize: [{
        id: 2,
        name: '公分(cm)'
      }, {
        id: 1,
        name: '英寸(inch)'
      }],
      activeSize: {},
      sizeColumns: [],
      sizeDataSource: [],
      selectedRowKeys: [],
      sizeDataSource2: [],
      measureList: [],
      isSupportSize: true,
      //是否支持尺码
      newSizeList: [],
      //尺码
      activeKey: '1',
      otherRuleForm: {
        unit: "",
        execStandard: "",
        securityLevel: undefined,
        currency: 'CNY',
        tagPrice: 0,
        craft: "",
        devCode: "",
        costPriceCurrency: 'CNY',
        series: undefined,
        tradeType: [],
        ladderConfigId: '',
        channel: 0,
        type: [],
        tradeArea: 1,
        reportList: [],
        isSupportOverseas: null,
        eColorBookId: undefined
      },
      otherLayout: {
        labelCol: {
          span: 8
        },
        wrapperCol: {
          span: 16
        },
        colSpan: 16
      },
      layout: {
        labelCol: {
          span: 20
        },
        wrapperCol: {
          span: 4
        },
        colSpan: 6,
        colSpanBig: 24
      },
      basicRuleForm: {
        styleNo: "",
        customerStyleNo: "",
        year: "",
        styleBand: undefined,
        name: "",
        season: "",
        //季节
        onSaleDate: "",
        brand: '',
        //织发
        classification: [],
        category: undefined,
        // series: undefined,
        // presale: undefined,
        description: '',
        supplierStyleCode: '',
        //供应商款号
        appropriate: '',
        //男装
        composition: "",
        //成分
        material: '',
        // 材质
        needleType: '',
        // 针型
        weight: '',
        //克重
        washings: [],
        //水洗

        serviceManagementIds: [],
        //服务
        performanceManagementIds: [],
        //表现
        certificationManagementIds: [] //认证
      }
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "otherRuleForm", {
      unit: "",
      execStandard: "",
      securityLevel: undefined,
      currency: 'CNY',
      tagPrice: 0,
      craft: "",
      devCode: "",
      costPriceCurrency: 'CNY',
      series: undefined,
      tradeType: [],
      ladderConfigId: '',
      channel: 0,
      type: [],
      tradeArea: 1,
      reportList: [],
      isSupportOverseas: null
    }), "basicRules", {
      // styleNo: [
      //   {
      //     required: false,
      //     message: "请输入大货款号",
      //     trigger: "change",
      //   },
      // ],
      pass: [{
        required: true,
        message: ""
      }],
      // lang: [
      //   {
      //     required: true,
      //     message: ""
      //   }
      // ],

      category: [{
        required: true,
        message: '',
        trigger: "change"
      }],
      // needleType:[
      //   {
      //     required:true,
      //     message: '',
      //     trigger: "change",
      //   }
      // ],
      // weight:[
      //   {
      //     required:true,
      //     message: '',
      //     trigger: "blur",
      //   }
      // ],
      appropriate: [{
        required: true,
        // message: '请选择人群',
        message: '',
        trigger: "change"
      }],
      season: [{
        required: true,
        // message: '请选择季节',
        message: '',
        trigger: "change"
      }],
      year: [{
        required: true,
        // message: "请选择年份",
        message: "",
        trigger: "change"
      }],
      name: [{
        required: true,
        message: "",
        // message: "请输入款式名称",
        trigger: "change"
      }],
      brand: [{
        required: true,
        // message: "请选择品牌",
        message: "",
        trigger: "change"
      }],
      classification: [{
        required: true,
        // message: "请选择类目",
        message: "",
        trigger: "change"
      }]
    }), "seasonList", []), "supportOverseasList", [{
      value: 1,
      label: '是'
    }, {
      value: 0,
      label: '否'
    }]), "yearList", []), "bandList", []), "brandList", []), "categoryList", []), "appropriateList", []), "needleTypeList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "washingList", []), "manage1", []), "manage2", []), "manage3", []), "Dynamic", {}), "DynamicList", []), "unitList", []), "securityLevelList", []), "showSeries", true), "seriesList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "channelList", [{
      id: 0,
      label: '线上'
    }, {
      id: 1,
      label: '线下'
    }]), "typeList", [{
      id: 0,
      label: '现货'
    }, {
      id: 1,
      label: '预售'
    }, {
      id: 2,
      label: '样品'
    }]), "sizeListShow", []), "testReportList", []), "eColorList", []), "colorList", []), "classificationId", ''), "classification2Id", ''), "classification3Id", ''), "classificationList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "classificationIdList", []), "multiLanguageDisplay", _multiLanguageDisplay.multiLanguageDisplay), "classificationId", null), "inventoryList", []), "inventoryColumn", [{
      title: '颜色编码',
      dataIndex: "pantone",
      key: "pantone",
      align: "center"
    }, {
      title: '颜色',
      dataIndex: "colorName",
      key: "colorName",
      align: "center"
    }, {
      title: '尺码',
      dataIndex: "size",
      key: "size",
      align: "center"
    }, {
      title: '在售库存',
      dataIndex: "onSaleNum",
      key: "onSaleNum",
      align: "center"
    }, {
      title: '已售库存',
      dataIndex: "soldNum",
      key: "soldNum",
      align: "center"
    }, {
      title: '占用库存',
      dataIndex: "occupancyNum",
      key: "occupancyNum",
      align: "center"
    }, {
      title: '库存',
      dataIndex: "num",
      key: "num",
      align: "center"
    }]);
  },
  mounted: function mounted() {
    this.init();
  },
  computed: {
    columns: function columns() {
      var obj1 = {
        title: '尺码',
        dataIndex: "size",
        key: "size",
        align: "center"
      };
      var obj2 = {
        title: '销售价格(CNY)',
        dataIndex: "salePrice",
        key: "salePrice",
        align: "center",
        slots: {
          title: 'CNY'
        }
      };
      var arr = [{
        title: "成本价格(CNY)",
        dataIndex: "costPrice",
        key: "costPrice",
        align: "center"
      }, {
        title: '利润',
        dataIndex: "profit",
        key: "profit",
        align: "center",
        slots: {
          title: 'profitTitle'
        }
      },
      // {
      //   title: '库存',
      //   dataIndex: "num",
      //   key: "num",
      //   align: "center",
      // },

      {
        title: '阶梯价',
        dataIndex: "ladd",
        key: "ladd",
        align: "center",
        fiexed: "right",
        width: 200
      }];
      var col = [],
        newArr = [];
      newArr = arr;
      if (this.isSupportSize) {
        if (this.otherRuleForm.isSupportOverseas != 1) {
          col = [obj1, obj2].concat((0, _toConsumableArray2.default)(newArr));
        } else {
          col = [obj1, obj2].concat((0, _toConsumableArray2.default)(newArr));
        }
      }
      if (!this.isSupportSize) {
        if (this.otherRuleForm.isSupportOverseas != 1) {
          col = [obj2].concat((0, _toConsumableArray2.default)(newArr));
        } else {
          col = [obj2].concat((0, _toConsumableArray2.default)(newArr));
        }
      }
      return col;
    },
    columns2: function columns2() {
      var obj1 = {
        title: '尺码',
        dataIndex: "size",
        key: "size",
        align: "center",
        scopedSlots: {
          customRender: 'size'
        }
      };
      var obj2 = {
        title: '销售价格(USD)',
        dataIndex: "salePrice",
        key: "salePrice",
        align: "center",
        slots: {
          title: 'USD'
        },
        scopedSlots: {
          customRender: 'salePrice'
        }
      };
      var arr = [{
        title: "成本价格(USD)",
        dataIndex: "costPrice",
        key: "costPrice",
        align: "center",
        scopedSlots: {
          customRender: 'costPrice'
        }
      }, {
        title: '利润',
        dataIndex: "profit",
        key: "profit",
        align: "center",
        slots: {
          title: 'profitTitle'
        },
        scopedSlots: {
          customRender: 'profit'
        }
      }, {
        title: '阶梯价',
        dataIndex: "ladd",
        key: "ladd",
        align: "center",
        width: 200,
        fiexed: "right",
        scopedSlots: {
          customRender: 'sale5'
        }
      }];
      var col = [],
        newArr = [];
      newArr = arr;
      if (this.isSupportSize) {
        if (this.otherRuleForm.isSupportOverseas != 1) {
          col = [obj1, obj2].concat((0, _toConsumableArray2.default)(newArr));
        } else {
          col = [obj1, obj2].concat((0, _toConsumableArray2.default)(newArr));
        }
      }
      if (!this.isSupportSize) {
        if (this.otherRuleForm.isSupportOverseas != 1) {
          col = [obj2].concat((0, _toConsumableArray2.default)(newArr));
        } else {
          col = [obj2].concat((0, _toConsumableArray2.default)(newArr));
        }
      }
      return col;
    }
  },
  filters: {
    name: function name(str) {
      try {
        var s = str.split('/'),
          l = s.length;
        return s[l - 1];
      } catch (error) {
        return str;
      }
    }
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    init: function init() {
      this.getDetail();
      this.getSizeType();
      this.getFee();
      this.getBrandList();
      this.getSeason();
      this.getYearList();
      this.getBandList();
      // this.getClassifyList()
      this.fetchPeople();
      this.getWashingList();
      this.getManageList();
      this.getUnitList();
      this.fetchWeave();
      this.fetchNeedleType();
      this.getSecurityLevelList();
      this.getEColorBookList();
      this.fetchSeries();
      this.getReportList();
    },
    onLadd: function onLadd(row, status) {
      this.laddData = row.ladderConfig;
      this.laddStatus = status;
      this.dialogVisible2 = true;
    },
    // 获取相关报告
    getReportList: function getReportList() {
      var _this = this;
      (0, _mall.getReportApi)({
        pageNo: 1,
        pageSize: 30
      }).then(function (res) {
        _this.testReportList = res.data.records;
      });
    },
    // 获取电子色卡列表数据
    getEColorBookList: function getEColorBookList() {
      var _this2 = this;
      (0, _mall.eColorBookList)().then(function (res) {
        _this2.eColorList = res.data;
      });
    },
    // 获取库存数据
    getInventoryData: function () {
      var _getInventoryData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(styleId) {
        var params, res, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                pageNo: 1,
                pageSize: 100,
                styleId: styleId
              };
              _context.n = 1;
              return (0, _mall.detailPage)(params);
            case 1:
              res = _context.v;
              data = res.data;
              this.inventoryData = data;
              this.inventoryList = data.page.records;
              console.log('data', data);
              // this.data = data;
              // this.list = data.page.records
              // this.total = data.page.total;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getInventoryData(_x) {
        return _getInventoryData.apply(this, arguments);
      }
      return getInventoryData;
    }(),
    // 获取单位下拉列表
    getUnitList: function getUnitList() {
      var _this3 = this;
      (0, _mall.getUnitPage)({
        pageNo: 1,
        pageSize: 40,
        name: ''
      }).then(function (res) {
        // this.dataSource = res.data.records;

        _this3.unitList = res.data.records.map(function (item) {
          return item.name;
        });
      });
    },
    // 获取服务认真管理数据
    getManageList: function () {
      var _getManageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(manageName) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                manageName: manageName
              };
              _context2.n = 1;
              return (0, _mall.listNO)(params);
            case 1:
              res = _context2.v;
              if (res.code == 0) {
                this.manage1 = res.data.filter(function (item) {
                  return item.type == 1;
                });
                this.manage2 = res.data.filter(function (item) {
                  return item.type == 2;
                });
                this.manage3 = res.data.filter(function (item) {
                  return item.type == 3;
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getManageList(_x2) {
        return _getManageList.apply(this, arguments);
      }
      return getManageList;
    }(),
    // 获取系列
    fetchSeries: function fetchSeries() {
      var _this4 = this;
      var data = {
        pageNo: 1,
        pageSize: -1,
        key: 'SERIES'
      };
      (0, _mall.getByPage)(data).then(function (res) {
        if (res.code == 0) {
          _this4.seriesList = res.data.records;
          _this4.seriesList.forEach(function (item) {
            item.label = _this4.multiLanguageDisplay(item.dictValue);
          });
        }
      });
    },
    // 获取季节
    getSeason: function getSeason() {
      var _this5 = this;
      var params = {
        pageNo: 1,
        pageSize: -1,
        key: 'SEASON'
      };
      (0, _mall.getSeasonApi)(params).then(function (res) {
        _this5.seasonList = res.data.records;
        _this5.seasonList.forEach(function (item) {
          item.label = _this5.multiLanguageDisplay(item.dictValue);
        });
      });
    },
    // 织法
    fetchWeave: function fetchWeave() {
      var _this6 = this;
      var params = {
        pageNo: 1,
        pageSize: -1,
        key: 'CATEGORY'
      };
      (0, _mall.getSeasonApi)(params).then(function (res) {
        _this6.categoryList = res.data.records;
        _this6.categoryList.forEach(function (item) {
          item.label = _this6.multiLanguageDisplay(item.dictValue);
        });
      });
    },
    // 年份
    getYearList: function getYearList() {
      var yearList = [];
      var now = new Date().getFullYear();
      var temp = now - 12;
      for (var index = 0; index < 50; index++) {
        yearList.push(temp++);
      }
      this.yearList = yearList;
      this.basicRuleForm.year = now;
    },
    // 获取水洗数据
    getWashingList: function () {
      var _getWashingList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(washingName) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                washingName: washingName
              };
              _context3.n = 1;
              return (0, _mall.washingListNO)(params);
            case 1:
              res = _context3.v;
              if (res.code == 0) {
                this.washingList = res.data;
                console.log('this.washingList', this.washingList);
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getWashingList(_x3) {
        return _getWashingList.apply(this, arguments);
      }
      return getWashingList;
    }(),
    // 获取波段
    getBandList: function getBandList() {
      var _this7 = this;
      (0, _mall.getBandApi)().then(function (res) {
        _this7.bandList = res.data;
        _this7.bandList.forEach(function (item) {
          item.label = _this7.multiLanguageDisplay(item.dictLabel);
        });
      });
    },
    // 获取品牌
    getBrandList: function getBrandList() {
      var _this8 = this;
      (0, _mall.brandListApi)().then(function (res) {
        if (res.code == 0) {
          console.log('res.data', res.data);
          _this8.brandList = res.data;
          _this8.brandList.forEach(function (item) {
            item.label = _this8.multiLanguageDisplay(item.dictLabel);
          });
        }
      });
    },
    // 获取类目
    getClassifyList: function () {
      var _getClassifyList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(type) {
        var _this9 = this;
        var res, listResult, classify;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return (0, _mall.classifyList)();
            case 1:
              res = _context4.v;
              if (res.code == 0) {
                listResult = JSON.parse(JSON.stringify(this.formatData(res.data))) || [];
                this.classificationList = listResult;
                classify = this.classificationList.find(function (item) {
                  return item.id === _this9.classificationId;
                });
                this.isSupportSize = classify.isSupportSize;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getClassifyList(_x4) {
        return _getClassifyList.apply(this, arguments);
      }
      return getClassifyList;
    }(),
    formatData: function formatData(data) {
      var _this0 = this;
      var that = this;
      data.forEach(function (element) {
        element.name = _this0.multiLanguageDisplay(element.name);
        if (element.children && element.children.length > 0) {
          that.formatData(element.children);
        } else {
          element.children = undefined;
        }
      });
      return data;
    },
    outNumber: function outNumber() {
      return function (val) {
        return NP.times(val ? val * 1 : 0, this.rate);
      };
    },
    changenewProfit: function changenewProfit(item) {
      var tagPrice = item.salePrice ? +item.salePrice : 0;
      var costPrice = item.costPrice ? +item.costPrice : 0;
      return Math.round((tagPrice * (1 - this.fee / 100) - costPrice) * 100) / 100 || 0;
    },
    getFee: function getFee() {
      var _this1 = this;
      (0, _mall.feeQuery)({
        code: "PLATFORM_SERVICE_FEE"
      }).then(function (res) {
        _this1.fee = res.data.feeRate;
      });
    },
    tabchange: function tabchange(tab, event) {
      console.log('key', tab.name, event);
      this.activeKey = tab.name;
    },
    onSelectType: function onSelectType(e) {
      var _this10 = this;
      this.activeSizeType = e;
      if (this.activeSizeType == 1 || !this.activeSizeType) {
        this.sizeList.forEach(function (item) {
          var row = _this10.sizeDataSource.find(function (row) {
            return row['1'] === item;
          });
          if (row) {
            _this10.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      } else {
        this.sizeList.forEach(function (item) {
          var row = _this10.sizeDataSource2.find(function (row) {
            return row['1'] === item;
          });
          if (row) {
            _this10.$refs.multipleTable2.toggleRowSelection(row, true);
          }
        });
      }
    },
    // 尺码选择
    onSize: function onSize(item) {
      this.activeSize = item;
      var aa = {
        title: this.multiLanguageDisplay(this.activeSize.name),
        dataIndex: this.activeSize.id,
        key: this.activeSize.id,
        align: "center",
        scopedSlots: {
          customRender: this.activeSize.id
        }
      };
      if (this.activeSize.id != this.sizeColumns[0].key) {
        this.sizeColumns[1] = aa;
        this.sizeColumns = [this.sizeColumns[0],
        // 保留第一个对象
        this.sizeColumns[1]].concat((0, _toConsumableArray2.default)(this.measureList.map(function (item) {
          return {
            title: item,
            dataIndex: item,
            key: item,
            align: "center",
            scopedSlots: {
              customRender: item
            }
          };
        })));
      } else {
        this.sizeColumns.splice(1, 1);
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取详情
    getDetail: function getDetail() {
      var _this11 = this;
      var params = {
        styleNo: this.$route.query.styleNo
      };
      (0, _mall.getDetailAPi)(params).then(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(res) {
          var imgList, aa, _imgList, _aa, newArry;
          return (0, _regenerator2.default)().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                console.log('详情', res);
                _this11.getInventoryData(res.data.styleId);
                // 商品款式图
                if (res.data.image) {
                  imgList = res.data.image.split(',');
                  aa = [];
                  imgList.forEach(function (item, index) {
                    aa.push({
                      name: "图片",
                      url: item,
                      uid: index
                    });
                  });
                  _this11.fileList = aa;
                } else {
                  _this11.fileList = [];
                }
                // 商品3d
                if (res.data.imageGif) {
                  _imgList = res.data.imageGif.split(',');
                  _aa = [];
                  _imgList.forEach(function (item, index) {
                    _aa.push({
                      name: "图片",
                      url: item,
                      uid: index
                    });
                  });
                  _this11.gifList = _imgList;
                } else {
                  _this11.gifList = [];
                }
                // 基础信息
                _this11.basicRuleForm = {
                  styleNo: res.data.styleNo,
                  customerStyleNo: res.data.customerStyleNo,
                  season: _this11.multiLanguageDisplay(res.data.season),
                  year: res.data.year,
                  name: res.data.name,
                  styleBand: res.data.styleBand,
                  onSaleDate: res.data.onSaleDate,
                  washings: res.data.washings.map(function (item) {
                    return item.washingId;
                  }),
                  serviceManagementIds: res.data.serviceManagements.map(function (item) {
                    return item.managementId;
                  }),
                  performanceManagementIds: res.data.performanceManagements.map(function (item) {
                    return item.managementId;
                  }),
                  certificationManagementIds: res.data.certificationManagements.map(function (item) {
                    return item.managementId;
                  }),
                  brand: _this11.multiLanguageDisplay(res.data.brand),
                  // 品牌
                  classification: [],
                  //类目
                  category: _this11.multiLanguageDisplay(res.data.category),
                  description: _this11.multiLanguageDisplay(res.data.description),
                  appropriate: _this11.multiLanguageDisplay(res.data.appropriate),
                  material: res.data.material,
                  needleType: _this11.multiLanguageDisplay(res.data.needleType),
                  weight: res.data.weight,
                  supplierStyleCode: res.data.supplierStyleCode
                };
                _this11.classificationId = res.data.classificationId ? res.data.classificationId : '';
                _this11.classification2Id = res.data.classification2Id ? res.data.classification2Id : '';
                _this11.classification3Id = res.data.classification3Id ? res.data.classification3Id : '';
                _this11.classificationIdList[0] = _this11.classificationId;
                _this11.classificationIdList[1] = _this11.classification2Id;
                _this11.classificationIdList[2] = _this11.classification3Id;
                _this11.getInfoSize(_this11.classificationId, _this11.classification2Id, _this11.classification3Id);
                // 其它信息
                _this11.otherRuleForm = {
                  channel: res.data.channel,
                  unit: res.data.unit,
                  isSupportOverseas: res.data.isSupportOverseas,
                  execStandard: _this11.multiLanguageDisplay(res.data.execStandard),
                  securityLevel: _this11.multiLanguageDisplay(res.data.securityLevel),
                  costPriceCurrency: res.data.costPriceCurrency,
                  currency: res.data.currency,
                  craft: res.data.craft,
                  devCode: res.data.devCode,
                  composition: res.data.composition,
                  series: (0, _multiLanguageDisplay.multiLanguageDisplay)(res.data.series),
                  tradeType: res.data.tradeType ? res.data.tradeType.split(',').map(function (item) {
                    return +item;
                  }) : [],
                  // ladderConfigId: newLadderConfigId ? res.data.ladderConfigId : 0,
                  tradeArea: res.data.tradeArea,
                  reportList: res.data.reportList ? res.data.reportList.split(',').map(Number) : [],
                  eColorBookId: res.data.eColorBookId ? res.data.eColorBookId : ''
                };
                // 成分
                _this11.compositionList = res.data.compositions;
                // 颜色
                newArry = res.data.colorList ? res.data.colorList : []; // this.colorId = newArry.map(item => item.colorId)
                _this11.colorList = newArry;
                // 尺码回显
                _this11.sizeGuide = JSON.parse(res.data.sizeGuide);
                // 遍历color数组，更新colorList
                if (JSON.parse(res.data.colorMoqConfig).length != 0) {
                  JSON.parse(res.data.colorMoqConfig).forEach(function (colorItem) {
                    _this11.colorList.forEach(function (item) {
                      if (item.colorId === colorItem.colorId) {
                        console.log('colorItem.priceDomestic', colorItem.priceDomestic);
                        var newarray = colorItem.priceDomestic && (0, _typeof2.default)(colorItem.priceDomestic) === 'object' ? Object.keys(colorItem.priceDomestic).map(function (key) {
                          return (0, _objectSpread2.default)({
                            size: key,
                            unit: 'CNY',
                            isEdit: false
                          }, colorItem.priceDomestic[key]);
                        }) : [];
                        console.log('2222222222222222222222', newarray, colorItem);
                        _this11.$set(item, 'num', colorItem.num); // 根据colorId设置num值
                        _this11.$set(item, 'presaleNum', colorItem.presaleNum);
                        _this11.$set(item, 'sampleNum', colorItem.sampleNum);
                        _this11.$set(item, 'size', colorItem.size);
                        _this11.$set(item, 'dataSource', newarray);
                        // 海外定价
                        var newarray2 = colorItem.priceForeign && (0, _typeof2.default)(colorItem.priceForeign) === 'object' ? Object.keys(colorItem.priceForeign).map(function (key) {
                          return (0, _objectSpread2.default)({
                            size: key,
                            unit: 'USD',
                            isEdit: false
                          }, colorItem.priceForeign[key]);
                        }) : [];
                        console.log('newarray2', newarray2);
                        _this11.$set(item, 'num1', colorItem.numForeign); // 根据colorId设置num值
                        _this11.$set(item, 'presaleForeignNum', colorItem.presaleForeignNum);
                        _this11.$set(item, 'sampleForeignNum', colorItem.sampleForeignNum);
                        _this11.$set(item, 'size', colorItem.size);
                        _this11.$set(item, 'dataSource2', newarray2);
                      }
                    });
                  });
                }
                _this11.specListTab = _this11.colorList;
                console.log('尺码回显', _this11.specListTab);
                _this11.specListTab.forEach(function (item) {
                  var img1 = [{
                    uid: 0,
                    name: "图片",
                    url: item.mainImage ? item.mainImage : []
                  }];
                  var img2 = [{
                    uid: 0,
                    name: "图片",
                    url: item.thumbImage ? item.thumbImage : []
                  }];
                  item.name = _this11.multiLanguageDisplay(item.name);
                  _this11.$set(item, 'mainImage', item.mainImage ? img1 : []);
                  _this11.$set(item, 'thumbImage', item.thumbImage ? img2 : []);
                  console.log('item', item);
                  if (item.dataSource) {
                    item.dataSource.forEach(function (citem) {
                      citem.ladderConfig.forEach(function (ccitem) {
                        ccitem.isEdit = false;
                      });
                      _this11.$set(citem, 'newLadderConfig', JSON.parse(JSON.stringify(citem.ladderConfig)));
                    });
                  }
                });
                if (_this11.specListTab.length != 0) {
                  _this11.activeKey = "".concat(_this11.specListTab[0].colorId);
                }
                // 回显勾选
                _this11.sizeList = res.data.checkSizeList ? JSON.parse(res.data.checkSizeList) : [];
                _context5.n = 1;
                return _this11.getClassifyList();
              case 1:
                _this11.$nextTick(function () {
                  if (_this11.activeSizeType == 1 || !_this11.activeSizeType) {
                    _this11.sizeList.forEach(function (item) {
                      var row = _this11.sizeDataSource.find(function (row) {
                        return row['1'] === item;
                      });
                      if (row) {
                        _this11.$refs.multipleTable.toggleRowSelection(row, true);
                      }
                    });
                  } else {
                    _this11.sizeList.forEach(function (item) {
                      var row = _this11.sizeDataSource2.find(function (row) {
                        return row['1'] === item;
                      });
                      if (row) {
                        _this11.$refs.multipleTable2.toggleRowSelection(row, true);
                      }
                    });
                  }
                });
              case 2:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.error('Error fetching config:', error);
      });
      // getDetailAPi(params).then(res => {
      //   console.log('详情',res)
      // })
    },
    // 获取人群
    fetchPeople: function fetchPeople() {
      var _this12 = this;
      var data = {
        pageNo: 1,
        pageSize: -1,
        key: 'APPROPRIATE'
      };
      (0, _mall.getByPage)(data).then(function (res) {
        if (res.code == 0) {
          _this12.appropriateList = res.data.records;
          _this12.appropriateList.forEach(function (item) {
            item.label = _this12.multiLanguageDisplay(item.dictValue);
          });
        }
      });
    },
    // 获取针种
    fetchNeedleType: function fetchNeedleType() {
      var _this13 = this;
      var data = {
        pageNo: 1,
        pageSize: -1,
        key: 'NEEDLE_TYPE'
      };
      (0, _mall.getByPage)(data).then(function (res) {
        if (res.code == 0) {
          _this13.needleTypeList = res.data.records;
          _this13.needleTypeList.forEach(function (item) {
            item.label = _this13.multiLanguageDisplay(item.dictValue);
          });
        }
      });
    },
    // 获取安全类别
    getSecurityLevelList: function getSecurityLevelList() {
      var _this14 = this;
      (0, _mall.safeList)().then(function (res) {
        _this14.securityLevelList = res.data;
        _this14.securityLevelList.forEach(function (item) {
          item.label = _this14.multiLanguageDisplay(item.dictLabel);
        });
      });
    },
    // 获取尺码类型
    getSizeType: function getSizeType() {
      var _this15 = this;
      (0, _mall.getCategoryApi)({}).then(function (res) {
        console.log('尺码类型', res);
        if (res.code == 0) {
          _this15.newSizeList = res.data;
          _this15.activeSize = _this15.newSizeList[0];
          _this15.sizeColumns.push({
            title: _this15.multiLanguageDisplay(_this15.newSizeList[0].name),
            dataIndex: _this15.newSizeList[0].id,
            key: "".concat(_this15.newSizeList[0].id),
            align: "center",
            scopedSlots: {
              customRender: _this15.newSizeList[0].id
            }
          });
        }
        console.log('尺码类型', _this15.newSizeList);
      });
    },
    // 根据类目获取尺码属性
    getInfoSize: function getInfoSize(id1, id2, id3) {
      var _this16 = this;
      var isClassify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var params = {
        category1Id: id1,
        category2Id: id2,
        category3Id: id3
      };
      (0, _mall.categoryApi)(params).then(function (res) {
        if (res.code == 0) {
          if (isClassify) {
            _this16.sizeGuide = {
              in: [],
              cm: []
            };
          }
          _this16.cateInfoSize = res.data;
          _this16.measureList = _this16.cateInfoSize && _this16.cateInfoSize.measureList ? _this16.cateInfoSize.measureList.map(function (item) {
            return (0, _multiLanguageDisplay.multiLanguageDisplay)(item);
          }) : [];
          _this16.mulMeasureList = _this16.cateInfoSize && _this16.cateInfoSize.measureList ? _this16.cateInfoSize.measureList.map(function (item) {
            return item;
          }) : [];
          _this16.sizeDataSource = _this16.cateInfoSize && _this16.cateInfoSize.sizeMap ? _this16.cateInfoSize.sizeMap : [];
          _this16.sizeListShow = _this16.cateInfoSize && _this16.cateInfoSize.commonSizeList;
          _this16.sizeDataSource.forEach(function (item) {
            _this16.$set(item, 'isEdit', false);
            _this16.measureList.forEach(function (citem) {
              if (!item[citem]) {
                _this16.$set(item, "".concat(citem), 0);
              }
            });
          });
          if (_this16.sizeGuide && _this16.sizeGuide.in.length != 0) {
            // 遍历 inArray
            _this16.sizeGuide.in.forEach(function (item) {
              var newValues = {};
              for (var key in item.values) {
                newValues[_this16.multiLanguageDisplay(key)] = item.values[key];
              }
              _this16.sizeDataSource.forEach(function (listItem) {
                if (listItem['1'] === item.size) {
                  // Object.assign(listItem, item.values);
                  Object.assign(listItem, newValues);
                }
              });
            });
          }
          _this16.sizeDataSource2 = JSON.parse(JSON.stringify(_this16.sizeDataSource));
          if (_this16.sizeGuide && _this16.sizeGuide.cm.length != 0) {
            // 遍历 inArray
            _this16.sizeGuide.cm.forEach(function (item) {
              var newValues = {};
              for (var key in item.values) {
                newValues[_this16.multiLanguageDisplay(key)] = item.values[key];
              }
              _this16.sizeDataSource2.forEach(function (listItem) {
                if (listItem['1'] === item.size) {
                  // Object.assign(listItem, item.values);
                  Object.assign(listItem, newValues);
                }
              });
            });
          }

          // this.sizeNewShow = (this.cateInfoSize&&this.cateInfoSize.sizeMap) ? this.cateInfoSize.sizeMap : []
          _this16.sizeColumns = [_this16.sizeColumns[0]].concat((0, _toConsumableArray2.default)(_this16.measureList.map(function (item) {
            return {
              title: item,
              dataIndex: item,
              key: "".concat(item),
              align: "center",
              scopedSlots: {
                customRender: item
              }
            };
          })));
        } else {
          _this16.sizeDataSource = [];
          _this16.sizeDataSource2 = [];
          // this.sizeNewShow = []
        }
      });
    }
  }, "fetchWeave", function fetchWeave() {
    var _this17 = this;
    var data = {
      pageNo: 1,
      pageSize: -1,
      key: 'CATEGORY'
    };
    (0, _mall.getByPage)(data).then(function (res) {
      if (res.code == 0) {
        _this17.categoryList = res.data.records;
        _this17.categoryList.forEach(function (item) {
          item.label = _this17.multiLanguageDisplay(item.dictValue);
        });
      }
    });
  }), "handleCancel", function handleCancel() {
    this.$router.push({
      path: '/goods/list'
    });
  }), "getDynamicValue", function getDynamicValue() {
    var _this18 = this;
    return function (name) {
      return _this18.Dynamic[name];
    };
  }), "handleSelectionChange", function handleSelectionChange(selection) {
    this.selectedRowKeys = selection.map(function (item) {
      return item['1'];
    });
  })
};